import AvatarFallback from "./AvatarFallback";
import React from "react";
import { Box, Typography } from "@mui/material";
import { MoreHorizontalIcon } from "../AdaptiveIcon";

import { ReactComponent as FacebookLike } from "../../images/facebookLike.svg";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
const Facebook = ({
  selectedAccounts,
  formattedTags,
  accResp,
  selectedImages,
  selectedIndex,
  avatars,
  postTitle,
  postText,
}) => {
  const numImages = selectedImages.length;

  // Facebook grid layout configurations
  const getGridStyle = () => {
    if (numImages === 1) {
      return {
        gridTemplateColumns: "1fr",
        gridTemplateRows: "1fr",
      };
    }
    if (numImages === 2) {
      return {
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "1fr",
      };
    }
    if (numImages === 3) {
      return {
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "1fr 1fr",
      };
    }
    return {
      gridTemplateColumns: "1fr 1fr",
      gridTemplateRows: "1fr 1fr",
    };
  };

  return (
    <Box className="flex justify-center p-2">
      <Box id="app">
        <Box
          className="instHeader mt-4"
          sx={{
            height: "20px",
            position: "relative",
            marginBottom: selectedAccounts.length === 0 ? "0px" : "30px",
          }}>
          {selectedAccounts.length === 0 ? (
            <Box
              className="avatar"
              sx={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                backgroundColor: "var(--background-preview)",
                position: "absolute",
              }}
            />
          ) : (
            <>
              {selectedAccounts.map((id, i) => {
                const index = accResp.findIndex((acc) => acc.id === id);
                const avatar = avatars[index];
                const userName = accResp[index].username;

                return (
                  <Box
                    key={id}
                    className="author-img"
                    sx={{
                      backgroundColor: "var(--background-preview)",
                      position: "absolute",
                      display: i === selectedIndex ? "flex" : "none",
                      alignItems: "center",
                    }}>
                    <AvatarFallback
                      src={avatar}
                      name={userName}
                      background="#1877f2"
                      className="w-full h-full object-cover mr-2"
                      style={{ borderRadius: "50%" }}
                    />
                    <Box className="flex column">
                      <Typography
                        className="whitespace-nowrap"
                        sx={{
                          marginLeft: "10px",
                          color: "var(--text-color)",
                        }}>
                        {userName}
                      </Typography>
                      <Typography
                        className="whitespace-nowrap"
                        sx={{
                          marginLeft: "10px",
                          color: "#a9a9a9",
                          fontSize: "12px",
                        }}>
                        Just now • <i className="global-icon"></i>
                      </Typography>
                    </Box>
                  </Box>
                );
              })}
            </>
          )}
          <Box className="absolute right-0">
            <MoreHorizontalIcon fontSize="large" />
          </Box>
        </Box>
        <Box
          className="user-info"
          style={{ position: "relative", paddingLeft: "60px", top: "-25px" }}>
          {selectedAccounts.length === undefined ||
          selectedAccounts.length === 0 ? (
            <>
              <Box
                style={{
                  width: "30%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}
              />
              <Box
                style={{
                  width: "10%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}
              />
            </>
          ) : null}
        </Box>

        {postText === undefined || postText === "" ? (
          <Box className="flex flex-col mb-2">
            <Box sx={{ width: "85%", display: "block", alignSelf: "center" }}>
              <Box
                style={{
                  width: "100%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
              <Box
                style={{
                  width: "80%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
              <Box
                style={{
                  width: "60%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
            </Box>
          </Box>
        ) : (
          <>
            <Typography
              component="div"
              style={{
                whiteSpace: "pre-wrap",
                overflow: "hidden",
                marginBottom: "12px",
                color: "var(--text-color)",
                fontSize: "15px",
                lineHeight: "1.5",
              }}>
              {postText}
            </Typography>
            <Typography
              component="div"
              style={{
                whiteSpace: "pre-wrap",
                overflow: "hidden",
                marginBottom: "5px",
                color: "#1877f2",
                fontSize: "15px",
              }}>
              {formattedTags}
            </Typography>
          </>
        )}

        {numImages > 0 && (
          <Box className="flex justify-center">
            <Box
              className="media-preview facebook-gallery"
              style={{ width: "523px", height: "auto", maxHeight: "523px" }}>
              <Box
                className="facebook-gallery-grid"
                style={{
                  display: "grid",
                  gap: "2px",
                  ...getGridStyle(),
                  position: "relative",
                }}>
                {numImages === 1 ? (
                  <img
                    src={selectedImages[0].props.src}
                    alt=""
                    style={{
                      width: "100%",
                      height: "523px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                ) : numImages === 2 ? (
                  selectedImages.slice(0, 2).map((image, index) => (
                    <img
                      key={index}
                      src={image.props.src}
                      alt=""
                      style={{
                        width: "100%",
                        height: "350px",
                        objectFit: "cover",
                        borderRadius: index === 0 ? "8px 0 0 8px" : "0 8px 8px 0",
                      }}
                    />
                  ))
                ) : numImages === 3 ? (
                  <>
                    <img
                      src={selectedImages[0].props.src}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        gridRow: "1 / 3",
                        borderRadius: "8px 0 0 8px",
                      }}
                    />
                    {selectedImages.slice(1, 3).map((image, index) => (
                      <img
                        key={index + 1}
                        src={image.props.src}
                        alt=""
                        style={{
                          width: "100%",
                          height: "175px",
                          objectFit: "cover",
                          borderRadius:
                            index === 0 ? "0 8px 0 0" : "0 0 8px 0",
                        }}
                      />
                    ))}
                  </>
                ) : (
                  <>
                    {selectedImages.slice(0, 4).map((image, index) => (
                      <Box
                        key={index}
                        style={{
                          position: "relative",
                          width: "100%",
                          height: "175px",
                        }}>
                        <img
                          src={image.props.src}
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius:
                              index === 0
                                ? "8px 0 0 0"
                                : index === 1
                                ? "0 8px 0 0"
                                : index === 2
                                ? "0 0 0 8px"
                                : "0 0 8px 0",
                          }}
                        />
                        {index === 3 && numImages > 4 && (
                          <Box
                            sx={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              backgroundColor: "rgba(0, 0, 0, 0.6)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "0 0 8px 0",
                            }}>
                            <Typography
                              sx={{
                                color: "#fff",
                                fontSize: "36px",
                                fontWeight: "bold",
                              }}>
                              +{numImages - 4}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    ))}
                  </>
                )}
              </Box>
            </Box>
          </Box>
        )}

        <Box className="feedback-info">
          <Box className="feedback-emojis">
            <i className="icons laugh-icon"></i>
            <i className="icons angry-icon"></i>
            <i className="icons wow-icon"></i>
            Tony Stark, Logan and 9487 others
          </Box>
          <Box className="threads-and-share">
            <Box className="threads"> 15 comments</Box>
          </Box>
        </Box>

        <Box className="feedback-action">
          <Box className="fb-wrapper gap-2">
            <FacebookLike
              style={{ fill: "#606770", width: "18px", height: "18px" }}
            />
            Like
          </Box>
          <Box className="fb-wrapper gap-2">
            <ChatBubbleOutlineOutlinedIcon
              sx={{ color: "#606770", width: "18px", height: "18px" }}
            />
            Comment
          </Box>
          <Box className="fb-wrapper gap-2">
            <i className="fb-icon share"></i>Share
          </Box>
        </Box>

        <Box className="comments">
          <Box className="my-comment-wrapper">
            {selectedAccounts.length === 0 ? (
              <Box
                className="avatar"
                sx={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  backgroundColor: "var(--background-preview)",
                  marginRight: "6px",
                }}
              />
            ) : (
              <>
                {selectedAccounts.map((id, i) => {
                  const index = accResp.findIndex((acc) => acc.id === id);
                  const avatar = avatars[index];
                  const userName = accResp[index].username;

                  return (
                    <img
                      key={id}
                      src={avatar}
                      alt=""
                      className="imageComment w-full h-full object-cover"
                      style={{
                        display: i === selectedIndex ? "flex" : "none",
                        borderRadius: "50%",
                      }}
                      onError={(e) => {
                        e.target.style.display = "none";
                        const placeholder = document.createElement('div');
                        placeholder.style.cssText = 'width:32px;height:32px;display:flex;align-items:center;' +
                          'justify-content:center;color:white;font-weight:bold;font-size:14px;border-radius:50%;' +
                          'background:#1877f2;margin-right:6px';
                        placeholder.textContent = userName.charAt(0).toUpperCase();
                        e.target.parentElement.appendChild(placeholder);
                      }}
                    />
                  );
                })}
              </>
            )}
            <Box className="my-comment">
              <Box className="my-comment-placeholder">
                <input type="text" placeholder="Write a comment..." />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Facebook;
